import React from "react";
import DeliveryPickUpWidget from "../../components/DeliveryPickUpWidget/DeliveryPickUpWidget";
import { store } from "../../redux/store";
import * as userActions from "../../redux/actions/user";
import { orderMethods, orderTypeIds } from "../constants/order";
import { shippingMethods, storeIds } from "../constants/store";
import * as orderRepo from "../repos/graphql/order";
import { getCartErrorMessage } from "./cart";

// Membership is a routing hint, not a stock or redemption eligibility check.
export const getProductFulfillment = (product, method, loyalty) => {
  const ids = (product?.stores || []).map(item => Number(item.id));
  const shipping = ids.includes(storeIds.shipping);
  const shippingOnly = shipping && ids.every(id =>
    id === storeIds.shipping || id === storeIds.sampleMenu
  );
  if (loyalty) {
    return method === orderMethods.shipping ? "local" : null;
  }
  if (shippingOnly && method !== orderMethods.shipping) return "shipping";
  if (ids.length && !shipping && method === orderMethods.shipping) return "local";
  return null;
};

/** Called only by an explicit PDP purchase action. Returns whether it intercepted it. */
export const requestProductFulfillment = (component, addToShippingCart) => {
  const { product } = component.state;
  const { userOrderMethod, loyalty, updateProduct, setModalObject } = component.props;
  const target = getProductFulfillment(product, userOrderMethod, loyalty);
  if (updateProduct || !target) return false;

  component.setState({ updateCartLoading: false, productAddError: "" });
  let started = false;
  const cancel = () => setModalObject(null);
  const confirm = async () => {
    if (started) return;
    started = true;
    if (target === "local") {
      // Selection only: the widget's productId shortcut loses quantity/options
      // and reward metadata. The customer adds from the configured PDP afterward.
      setModalObject({
        children: <DeliveryPickUpWidget isModal preserveProductPage analyticsPageSection="Product Image" />
      });
      return;
    }
    component.setState({ updateCartLoading: true });
    try {
      // Create first, so a failed request leaves the customer's current cart intact.
      const response = await orderRepo.createCart({
        orderTypeId: orderTypeIds.shipping,
        shippingMethod: shippingMethods.shipping,
        storeId: storeIds.shipping
      }, { replaceOrder: true });
      const cart = response.data.createCart;
      store.dispatch(userActions.setUserCart([]));
      store.dispatch(userActions.setUserCartId(cart.code));
      store.dispatch(userActions.setUserAddress(""));
      store.dispatch(userActions.setSelectedStore({ id: storeIds.shipping }));
      store.dispatch(userActions.setUserOrderMethod(orderMethods.shipping));
      setModalObject(null);
      await addToShippingCart(cart.code);
    } catch (error) {
      started = false;
      component.setState({ productAddError: getCartErrorMessage(error) });
      setModalObject(null);
    } finally {
      component.setState({ updateCartLoading: false });
    }
  };
  setModalObject({
    title: target === "shipping" ? "Continue to Shipping?" : "Choose Delivery or Pickup",
    description: target === "shipping"
      ? "This product is shipping only. Continuing starts a new shipping cart and adds your selected product. Your current cart will be replaced."
      : "This product requires Delivery or Pickup. Choose your location, then add your configured product from this page.",
    action1Label: "Cancel",
    action1: cancel,
    action2Label: "Continue",
    action2: confirm
  });
  return true;
};
